import script from "./auth-phone-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-phone-form.vue?vue&type=script&lang=ts&setup=true"

import "./auth-phone-form.vue?vue&type=style&index=0&id=057dd57a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057dd57a"]])

export default __exports__